import SearchModuleRooms from './SearchModuleRooms';

export default SearchModuleRooms;
